import React from 'react';
import {Box, Typography} from '@mui/material';
import PdfIcon from '../../../assets/icons/pdf_ocr.svg';
import {PDFContainer, PDFEmbed} from "./PDFViewer.styled";
import {useTranslation} from "react-i18next";

interface PDFViewerProps {
    previewUrl: string | null;
    fileName: string;
}

const PDFViewer = ({ previewUrl, fileName }: PDFViewerProps) => {
    const { t } = useTranslation();

    // view before processing
    if (!previewUrl) {
        return (
            <Box display="flex" flexDirection="column" alignItems="center" gap={2} p={4}>
                <img src={PdfIcon}
                     alt={t('ocr.aria.previewPdf') as string}
                     style={{ width: '48px', height: '48px' }}
                />

                <Typography variant="body2" color="textSecondary">
                    {fileName}
                </Typography>
            </Box>
        );
    }

    // view after processing
    return (
        <PDFContainer>
            <PDFEmbed
                src={previewUrl}
                type="application/pdf"
                title={fileName}
            />
        </PDFContainer>
    );
};

export default PDFViewer;